import { request } from '../request';

const cart = {
  addCart: (data) => request('/api/cart/store', 'post', data), // 添加购物车
  cartList: (data) => request('/api/cart/lists', 'get', data), // 购物车列表
  pointMallCartList: (data) => request('/api/customer/cart/point_mall_list', 'get', data), // 积分商城购物车列表（只会有一条）
  updateCart: (data) => request('/api/cart/update', 'put', data), // 更新购物车中处方和数量和商品
  deleteCart: (data) => request('/api/cart/delete', 'delete', data), // 删除购物车中商品
  getCartPrice: (data) => request('/api/cart/get_cart_price', 'get', data), // 购物车计价
  getCartColorList: (data) => request('/api/cart/get_same_spu_products', 'get', data), // 获取同spu的商品
  check: (data) => request('/api/cart/check', 'post', data, { errorMsg: false }), // 购物车跳转结算页面前检查
  igStoreCart: (data) => request('/api/cart/ig_store', 'post', data), // igStore 批量加购接口（从ig小店跳转过来）
};
export default cart;
